module.exports = __webpack_public_path__ + "img/empty-light.52a32dc7.png";